import { OperatorPortalWorkPage } from "@/components/non_registrant/operator-portal-pages";
import { validateOperatorRegistrationsSearch } from "@/lib/title-request-case-link";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/inactive-registrations")({
  validateSearch: validateOperatorRegistrationsSearch,
  component: OperatorPortalWorkPage,
});
